import {createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const headers = {
    'x-bingapis-sdk': 'true',
    'x-rapidapi-host': 'bing-news-search1.p.rapidapi.com',
    'x-rapidapi-key': '35f0e8c68dmshcc1768d061f1c3dp1cbd3bjsne3777f68063f'
};

const baseUrl = 'https://bing-news-search1.p.rapidapi.com';

export const cryptoNewsApi = createApi({
    reducerPath: "cryptoNewsApi",
    baseQuery: fetchBaseQuery({baseUrl}),
    endpoints: (builder) => ({
        cryptoNews: builder.query({
            query: (crypto) => ({url: `/news/search?q=${crypto}&safeSearch=Off&textFormat=Raw&freshness=Day`, headers})
        }),
        stockNews: builder.query({
            query: (stock) =>  ({url: `/news/search?q=${stock}&safeSearch=Off&textFormat=Raw&freshness=Day`, headers})
        })
    })
})

export const {useCryptoNewsQuery, useStockNewsQuery} = cryptoNewsApi;